import {BaseModel} from "crqlar-react-common/dist/models/common/base.model"
import {UseEntityData} from "crqlar-react-common/dist/components/useEntity"

/**
 * Whether a mandatory field on a settings detail page should render its error state.
 *
 * Derived from that field's own value only — deliberately NOT from `isDirty`, which would light the
 * field up as soon as any unrelated field is edited. Suppressed while the entity is still loading or
 * missing entirely, otherwise every existing record flashes red before its data arrives.
 *
 * Mirror this in whatever `isValid` the page passes to `useEntity`, so the red outline and the
 * disabled Save button always agree on what is missing.
 */
export const isRequiredTextMissing = <T extends BaseModel>(
    data: UseEntityData<T>,
    value: string | null | undefined
) => !data.loading && !data.isMissing && !value?.trim()

/** As above, for mandatory single-select fields where "nothing picked" arrives as undefined. */
export const isRequiredValueMissing = <T extends BaseModel>(
    data: UseEntityData<T>,
    value: string | null | undefined
) => !data.loading && !data.isMissing && !value

/** As above, for mandatory numeric fields where an empty input arrives as undefined or NaN. */
export const isRequiredNumberMissing = <T extends BaseModel>(
    data: UseEntityData<T>,
    value: number | null | undefined
) => !data.loading && !data.isMissing && (value === undefined || value === null || isNaN(value))
